import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'
import { useCurrentUser } from '@/api/hooks'

const STORAGE_KEY = 'dashboard-my-projects-filter'

interface MyProjectsFilterContextValue {
  showMyProjects: boolean
  setShowMyProjects: (v: boolean) => void
  opsPersonId: number | undefined
  staffId: number | undefined
}

const MyProjectsFilterContext = createContext<MyProjectsFilterContextValue>({
  showMyProjects: false,
  setShowMyProjects: () => {},
  opsPersonId: undefined,
  staffId: undefined,
})

export function MyProjectsFilterProvider({ children }: { children: ReactNode }) {
  const { data: currentUser } = useCurrentUser()
  const [showMyProjects, setShowMyProjects] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  })

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(showMyProjects))
  }, [showMyProjects])

  const opsPersonId = showMyProjects ? currentUser?.id : undefined
  const staffId = showMyProjects ? currentUser?.id : undefined

  return (
    <MyProjectsFilterContext value={{ showMyProjects, setShowMyProjects, opsPersonId, staffId }}>
      {children}
    </MyProjectsFilterContext>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useMyProjectsFilter() {
  return useContext(MyProjectsFilterContext)
}
